<template>
  <div>
      <div class="transition">
        <v-expansion-panels>
          <v-expansion-panel
            v-for="(every_transition,index) in data"
            :key="index"
          >
            <v-expansion-panel-header>
              {{every_transition.id}}
              <AddTransition
                v-if="!readonly"
                :bp="bp"
                :field="every_transition"
                @submit="(new_value) => {update(index,new_value)}"
                custom_icon="mdi-pencil"
              />
            </v-expansion-panel-header>
            <v-expansion-panel-content>
            <Input
                :value="transition_details(every_transition)"
                :readonly="readonly"
                :roles="roles"
                @update="(value) => {update(index,value)}"
              />
              <DialogFormInput
                class="qmkey-transition"
                :raw_fields="(bp.raw.transitions[index] || {}).layout || []"
                :parsed_fields="(bp._parsed_transitions || [])[index]"
                :bp="bp"
                :bp_index="index"
                :readonly="readonly"
                :lang="lang"
                :is_mobile="is_mobile"
                @update="(value) => {update_layout(index,value)}"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <AddTransition
          v-if="!readonly"
          :bp="bp"
          @submit="new_prop"
        />
      </div>
  </div>
</template>

<style lang="scss">
  .transition{
    border:1px;
    border-width: 1px;
    border-color: black;
  }
  .qmkey-transition{
    //background-color: lightpink;
    border: 1px solid white;
    margin: 4px;
    padding: 4px;
  }
</style>
    
<script>
  import DialogFormInput from '@/components/bpcreator/inputs/DialogFormInput';
  import Input from '@/components/bpcreator/inputs/Input';
  import AddTransition from '@/components/bpcreator/model/AddTransition';
  export default {
    components: {
      Input,
      AddTransition,
      DialogFormInput,
    },
        
    name: 'Transitions',
        
    props: {
      bp: {default: () => ({})},
      data: {default: () => ({})},
      readonly: Boolean,
      is_mobile: Boolean,
      lang: String,
      roles: {default: ()=>({})},
    },
        
    data: () => ({
    }),
        
    computed: {
    },
        
    mounted() {
    },

    methods: {
      transition_details(transition) {
        let trans = {...transition};
        delete trans.layout;
        return trans;
      },
      parse_layout(layout){
        return layout.map(it => it.map(([key,value]) => 
          ({...value,... (this.bp || {}).bp[key]})
        ))
      },
      update(index,value) {
        let new_item = [...this.data];
        if(index >= new_item.length) {
          new_item.push(value);
        } else {
          new_item[index] = value;
        }
        this.$emit('update', new_item);
      },
      update_layout(index,value) {
        let new_transition = {...this.data[index]}
        new_transition.layout = value;
        this.update(index,new_transition)
      },

      new_prop(value) {
        let item = {...value};
        value.layout = [];
        this.update(this.data.length,item);
      },
    },
    
    watch: {
    },
  }
</script>